import { ReactElement } from 'react';
import { Score } from './components/Score/Score';
import {
  RatingSt,
  RatingHeaderSt,
  DescriptionSt,
  RatingTitleSt,
  SummarySt,
  RatingBodySt,
  BulletsSt,
  BulletTitleSt,
  ConsBulletsWrapperSt,
  ProsBulletsWrapperSt,
} from './Rating.css';
import { DangerousElement } from 'app/shared/components/DangerousElement/DangerousElement';
import Translation from 'app/shared/components/Translation/Translation';

export interface IRatingProps {
  summary: string;
  rating: number;
  proBulletsContent?: string;
  conBulletsContent?: string;
}

const Rating = ({
  summary,
  rating,
  proBulletsContent,
  conBulletsContent,
}: IRatingProps): ReactElement => {
  return (
    <RatingSt>
      <RatingHeaderSt>
        <Score value={rating} max={10} />
        <DescriptionSt>
          <RatingTitleSt>
            <Translation
              id="shared.components.contentful.blocks.modelSpecificCTA.title"
              defaultMessage="heycar Review"
            />
          </RatingTitleSt>
          <SummarySt>{summary}</SummarySt>
        </DescriptionSt>
      </RatingHeaderSt>
      <RatingBodySt>
        {!!proBulletsContent && (
          <BulletsSt>
            <BulletTitleSt>
              <Translation
                id="shared.components.contentful.blocks.rating.proLabel"
                defaultMessage="Good bits"
              />
            </BulletTitleSt>
            <ProsBulletsWrapperSt>
              <DangerousElement html={proBulletsContent} />
            </ProsBulletsWrapperSt>
          </BulletsSt>
        )}
        {!!conBulletsContent && (
          <BulletsSt>
            <BulletTitleSt>
              <Translation
                id="shared.components.contentful.blocks.rating.conLabel"
                defaultMessage="Not so great"
              />
            </BulletTitleSt>
            <ConsBulletsWrapperSt>
              <DangerousElement html={conBulletsContent} />
            </ConsBulletsWrapperSt>
          </BulletsSt>
        )}
      </RatingBodySt>
    </RatingSt>
  );
};

export { Rating };
